import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}`

    return {
        calcularIMC: async ({ unidade_medida_massa_id, massa, unidade_medida_altura_id, altura }) => {
            return repository.get(`${baseUrl}/geral/imc/${unidade_medida_massa_id}/${massa}/${unidade_medida_altura_id}/${altura}`)
        },
        unidadeMedida: async ({ origem_id, valor, destino_id }) => {
            return repository.get(`${baseUrl}/geral/conversao/unidade-medida/${origem_id}/${valor}/${destino_id}`)
        },
        calcularDPP: async ({ ano, mes, dia }) => {
            return repository.get(`${baseUrl}/geral/gestacao/calculos/${ano}/${mes}/${dia}`)
        },
        calcularDiferencaTempo({ ano, mes, dia }) {
            return repository.get(`${baseUrl}/geral/diferenca-tempo/${ano}/${mes}/${dia}`)
        },
        getTermosInvalidos() {
            return repository.get(`${baseUrl}/geral/termo-invalido`)
        },
        ciap: {
            autocomplete(queryParms = {}) {
                return repository.get(`${baseUrl}/geral/ciap/autocomplete?${urlUtil.serialize(queryParms)}`)
            },
            index(queryParms = {}) {
                return repository.get(`${baseUrl}/geral/ciap?${urlUtil.serialize(queryParms)}`)
            },
        },
    }
}